import createSharedEngineListFactory from "../../../../rx/memo/createSharedEngineListFactory"

const useEnginePropertyLightsBlinkingObjectList = createSharedEngineListFactory<(lightsOn: boolean) => void>()

export default useEnginePropertyLightsBlinkingObjectList